import ReactPiGrid from '@/pages/pi/grid/react';

const Grid = ReactPiGrid;

export default Grid;
